import { useRef, useState, useLayoutEffect } from "react";
import DashboardBranding from "@/components/dashboard/DashboardBranding";
import DashboardCertificationCycles from "@/components/dashboard/DashboardCertificationCycles";
import DashboardDataDiscrepancies from "@/components/dashboard/DashboardDiscrepancies";
import DashboardHeading from "@/components/dashboard/DashboardHeading";
import DashboardMessages from "@/components/dashboard/DashboardMessages";
import DashboardStats from "@/components/dashboard/DashboardStats";
import LayoutContentArea from "@/components/layout/LayoutContentArea";
import { useRouteContext, useParams } from "@tanstack/react-router";

const STATE_LEVEL_LEAID = "0-";

const Dashboard = () => {
  const leaContext = useRouteContext({ from: "/$leaid" });
  const params = useParams({ strict: false });

  const leftColRef = useRef<HTMLDivElement>(null);
  const [leftHeight, setLeftHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    const el = leftColRef.current;
    if (!el) return;

    const mq = window.matchMedia("(min-width: 1200px)");

    const update = () => {
      setLeftHeight(mq.matches ? el.offsetHeight : undefined);
    };

    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    mq.addEventListener("change", update);
    return () => {
      ro.disconnect();
      mq.removeEventListener("change", update);
    };
  }, []);

  if (params.leaid === STATE_LEVEL_LEAID) {
    return (
      <LayoutContentArea headingText="Welcome to the State Level">
        <p className="text-muted">
          Select an option from the menu to get started.
        </p>
      </LayoutContentArea>
    );
  }

  if (!leaContext.hasFeature("Dashboard")) {
    return (
      <LayoutContentArea headingText="LEA Dashboard">
        Content in development
      </LayoutContentArea>
    );
  }

  return (
    <LayoutContentArea
      headingText={null}
      noBorder={true}
      showHeadingSection={false}
    >
      <DashboardBranding />
      <DashboardHeading />
      <DashboardStats />
      <div className="row g-4 mt-1 align-items-start">
        <div
          className="col-12 col-xl-8 d-flex flex-column gap-3"
          ref={leftColRef}
        >
          {leaContext.hasRole("ReportsEOY", "ReportsFall", "ReportsMonthly") && (
            <DashboardCertificationCycles />
          )}
          {leaContext.hasRole("Extracts") && (
            <div className="flex-grow-1">
              <DashboardDataDiscrepancies />
            </div>
          )}
        </div>
        <div className="col-12 col-xl-4">
          <div
            style={{
              maxHeight: leftHeight,
              minHeight: 0,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <DashboardMessages />
          </div>
        </div>
      </div>
    </LayoutContentArea>
  );
};

export default Dashboard;
